function DesignPreview() {

}

DesignPreview.events = {
    is_init_events_called: 0,
    reCaptcha: undefined,

    init: function() {
        var _this = this;
        if (DesignPreview.events.is_init_events_called === 0) {
            $("#right-pane-column").on('click', '.richardson-footer .uniform-summary-preview', function(event) {
                // Check conflict
                var applicationWithConflict = ApplicationCore.utilities.getAllEmbellishments(true);
                if (_.size(applicationWithConflict) > 0) {
                    ApplicationList.events.loadApplicationConflict(applicationWithConflict);
                } else {
                    // Show confirmation
                    if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
                        _this.loadViewSummary();
                    } else {
                        UIkit.modal("#roster-confirmation").show();
                    }
                }
            });

            $("#richardson-saving-option").on("click", ".switch-reg-login", function() {
                var type = $(this).data("type");

                if (type === "login") {
                    $("#richardson-saving-option .login-container").removeClass("uk-hidden");
                    $("#richardson-saving-option .registration-container").addClass("uk-hidden");
                } else {
                    $("#richardson-saving-option .registration-container").removeClass("uk-hidden");
                    $("#richardson-saving-option .login-container").addClass("uk-hidden");
                }
            });

            $("#richardson-saving-option").on("click", ".summary-content .save-my-design", _this.onSaveToMyDesign);

            $("#richardson-saving-option").on("submit", "form#send-email", _this.onSubmitFormSendEmail);
            $("#richardson-saving-option").on("submit", "form#login-customer", _this.onSubmitFormLoginCustomer);
            $("#richardson-saving-option").on("submit", "form#registration-form", _this.onSubmitFormRegistration);

            $("#richardson-saving-option").on("click", ".cart-container .add-to-cart", _this.onAddToCart);
            $("#richardson-saving-option").on("click", ".cart-container .go-to-cart", _this.goToCart);
            $("#richardson-saving-option").on("click", ".cart-container .back-to-designer", _this.backToDesigner);
            // $("#richardson-saving-option").on("click", ".save-design-container .mysaved-design", _this.onClickToMySavedDesign);

            $("#roster-confirmation").on('click', '.confirmation-answer', function() {
                var answer = $(this).data('answer');
                UIkit.modal("#roster-confirmation").hide();
                if (answer.toLowerCase() === "yes") {
                    RosterPanel.events.init();
                    RosterPanel.events.onShowRoster();
                } else {
                    _this.loadViewSummary();
                }
            });

            DesignPreview.events.is_init_events_called = 1;
        }
    },

    loadViewSummary: function() {
        var _this = this;
        $("#richardson-saving-option form#save-design-form").trigger("reset");
        if (_this.isUniformChange() || ub.data.rosterIsChange) {
            // Hide Main Content Container
            $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
            // Show loading screen
            DesignPreview.events.showLoader();

            // Set All to undefined and false
            ub.current_material.settings.savedDesignID = undefined;
            ub.current_material.settings.design_number_magento = undefined;
            ub.data.addedToCart = false;
            ub.data.isSavedDesign = false;

            if (ub.user) {
                ub.current_material.settings.userFullName = ub.user.fullname;
            }

            // Empty PDF container 
            $("#richardson-saving-option .pdf-container").html("");

            // Prepare Thumbnails and other settings
            SaveDesign.prepareThumbnails()
        } else {
            $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
            $('#richardson-saving-option .save-design-loading').fadeOut();
        }

        // Render UI
        _this.renderDesignPreview();
        // Setup After Loads 
        _this.afterLoadingDesignPreviewAssets();

        UIkit.modal("#richardson-saving-option").show();
    },

    /**
        EVENTS
    */

    onSaveToMyDesign: function() {
        $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeIn();
        $("#richardson-saving-option .loading-message").html("");
        $("#richardson-saving-option .loading-message").html("Saving design......");


        var payload = {
            "image": ub.current_material.settings.thumbnails.front_view,
            "customerID": ub.user.id,
            "design_id": ub.current_material.settings.savedDesignID,
            "url": DesignPreview.events.getSavedDesignRedirectUrl(),
            "pdf_url": ub.current_material.settings.uniformPreviewPdf,
            "designID": ub.current_material.settings.savedDesignID
        };

        if (typeof ub.current_material.settings.thumbnailsLowRes !== "undefined") {
            if (ub.current_material.settings.thumbnailsLowRes.front_view !== "undefined") {
                payload.image = ub.current_material.settings.thumbnailsLowRes.front_view;
            }
        }

        if (typeof ub.user.origin !== "undefined" && ub.user.origin === "design-preview") {
            SaveDesign.updateDesignWithCallback(function() {
                ub.utilities.info("Saved design updated");
                if (ub.config.isMagentoVersionTwo) {
                    RMagento.saveDesignV2(payload);
                } else {
                    RMagento.saveDesign(payload);
                }
            });
        } else {
            if (ub.config.isMagentoVersionTwo) {
                RMagento.saveDesignV2(payload);
            } else {
                RMagento.saveDesign(payload);
            }
        }
    },

    onSubmitFormSendEmail: function(event) {
        event.preventDefault();
        var mainFormElement = $("#richardson-saving-option form#send-email");
        var payload = {
            "dealer_email": $("input.receiver-email", mainFormElement).val(),
            "your_email": $("input.sender-email", mainFormElement).val(),
            "your_name": $("input.sender-name", mainFormElement).val(),
            "message": $("textarea.sender-message", mainFormElement).val(),
            "pdf_url": ub.current_material.settings.uniformPreviewPdf,
            "pdf_name": "Richardson Customizer",
        };

        let designUrl = DesignPreview.events.getSavedDesignRedirectUrl();

        var response = grecaptcha.getResponse(DesignPreview.events.reCaptcha);

        if (_.size(response) > 0) {
            // Show Loader
            DesignPreview.events.showLoader();

            var savedDesignID = ub.current_material.settings.savedDesignID;
            payload.design_number = savedDesignID;
            payload.design_url = designUrl;
            payload.image_url = ub.current_material.settings.thumbnails.front_view;
            payload["g-recaptcha-response"] = response;
            if (typeof ub.current_material.settings.thumbnailsLowRes !== "undefined") {
                if (ub.current_material.settings.thumbnailsLowRes.front_view !== "undefined") {
                    payload.image_url = ub.current_material.settings.thumbnailsLowRes.front_view;
                }
            }

            // Send Email
            if (typeof ub.user.origin !== "undefined" && ub.user.origin === "design-preview") {
                SaveDesign.updateDesignWithCallback(function() {
                    ub.utilities.info("Saved design updated");
                    RMagento.sendEmail(payload);
                });
            } else {
                RMagento.sendEmail(payload);
            }
            
        } else {
            var render = DesignPreview.events.showAlertMessage("reCAPTCHA is required.", "danger");
            $(".send-design-container .message-container").html("");
            $(".send-design-container .message-container").html(render);

            DesignPreview.events.hideMessage();
        }
    },

    onSubmitFormLoginCustomer: function(event) {
        event.preventDefault();
        var mainFormElement = $("#richardson-saving-option form#login-customer");
        var render;

        DesignPreview.events.showLoader();

        var data = {
            "email": $("input.email", mainFormElement).val(),
            "password": $("input.password", mainFormElement).val(),
        };

        if (data.email.length === 0) {
            render = Mustache.render(tmpl, {message: "Email is required"});
            $("form#login-customer input[name='email']").addClass('uk-form-danger');
            $("form#login-customer input[name='email']").parent().parent().append(render);
        }

        if (data.password.length === 0) {
            render = Mustache.render(tmpl, {message: "Password is required"});
            $("form#login-customer input[name='password']").addClass('uk-form-danger');
            $("form#login-customer input[name='password']").parent().parent().append(render);
        }


        RichardsonLogin.events.postUserLogin(data.email, data.password, "finish");
    },

    onSubmitFormRegistration: function(event) {
        event.preventDefault();

        var mainFormElement = $("#richardson-saving-option form#registration-form");

        var password = $("input.password", mainFormElement).val();
        var confirm_password = $("input.confirm-password", mainFormElement).val();

        if (password !== confirm_password) {
            var render = DesignPreview.events.showAlertMessage("Password not match", "danger");

            $(".registration-container .message-container").html("");
            $(".registration-container .message-container").html(render);

            $("form#registration-form input.confirm-password").addClass('uk-form-danger');
            return;
        }

        var data = {
            "name": $("input.name", mainFormElement).val(),
            "email": $("input.email", mainFormElement).val(),
            "password": password,
        };

        DesignPreview.events.showLoader();
        RMagento.registerUser(data);
    },

    onAddToCart: function() {
        var ajax_type;
        if (ub.config.addCartJson !== "1" || ub.config.addCartJson === "") {
            ajax_type = "";
        } else {
            ajax_type = "json";
        }

        var sizes = ub.current_material.settings.size_breakdown;

        if (ub.funcs.is_pts_sock()) {
            sizes = ub.current_material.settings.sockSizing;
        }

        var data = {
            "customer_id": ub.user.id,
            "model_id": ub.current_material.material.style_number, 
            "sizes": JSON.stringify(sizes),
            "pdf_url": ub.current_material.settings.uniformPreviewPdf,
            "ajax_type": ajax_type,
        }

        if (typeof ub.current_material.settings.size_breakdown !== "undefined" && _.size(ub.current_material.settings.size_breakdown) > 0) {
            DesignPreview.events.showLoader();
            Cart.addCart(data);
        } else {
            $(this).addClass("uk-disabled");
            ub.utilities.notifyMe("Please add item in your roster before adding to cart.", "danger");
        }
    },

    goToCart: function() {
        window.onbeforeunload = null;

        _.delay(function() {
            var url = ub.config.magentoURL + "/checkout/cart";
            window.parent.location.replace(url);
        }, 500)
    },

    backToDesigner: function() {
        UIkit.modal("#richardson-saving-option").hide();
    },

    /**
        HELPER FUNCTIONS
    */

    // Check if the uniform has been modified
    isUniformChange: function() {
        if (typeof ub.data.previousThumbnails === "undefined") {
            return true;
        } else {
            var isChangeFront = ub.data.previousThumbnails["front_view"] !== ub.getThumbnailImage("front_view");
            var isChangeBack = ub.data.previousThumbnails["back_view"] !== ub.getThumbnailImage("back_view");
            var isChangeLeft = ub.data.previousThumbnails["left_view"] !== ub.getThumbnailImage("left_view");
            var isChangeRight = ub.data.previousThumbnails["right_view"] !== ub.getThumbnailImage("right_view");
            var isChangeThumbnails = false;

            isChangeThumbnails = isChangeFront || isChangeBack || isChangeLeft || isChangeRight;

            return isChangeThumbnails;
        }
    },

    showLoader: function() {
        $('#richardson-saving-option .save-design-loading').fadeIn();
        $("#richardson-saving-option .uniform-thumbnail-container").addClass("uk-hidden");
    },

    hideLoader: function() {
        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeOut();
    },

    showSavedDesign: function() {
        var mySavedDesingURL = DesignPreview.events.getMySavedDesignURL();

        var template = document.getElementById("m-summary-saved-design").innerHTML;
        var render = Mustache.render(template, {
            mySavedDesingURL
        });

        $("#richardson-saving-option .save-design-container").html("");
        $("#richardson-saving-option .save-design-container").html(render);
        $("#richardson-saving-option .design-id").val(ub.config.material_id);
    },

    showAlertMessage: function(message, type) {
        var template = document.getElementById("m-alert-message").innerHTML;
        var render = Mustache.render(template, {message: message, type: type});

        return render;
    },

    hideMessage: function() {
        _.delay(function() {
            $("#richardson-saving-option .message-container").html("");
        }, 5000);
    },

    reIniateSavingOptionUI: function() {
        var template = '';
        if (ub.funcs.isDealer()) {
            template = document.getElementById("m-summary-dealer").innerHTML;
        } else if (ub.funcs.isPlayer()) {
            template = document.getElementById("m-summary-player").innerHTML;
        } else {
            template = document.getElementById("m-summary-guest").innerHTML;
        }

        var mySavedDesingURL = DesignPreview.events.getMySavedDesignURL();

        var renderTemplate = Mustache.render(template, {
            mySavedDesingURL
        });
        
        $("#richardson-saving-option .summary-content").html("");
        $("#richardson-saving-option .summary-content").html(renderTemplate);
        $("#richardson-saving-option .design-id").val(ub.config.material_id);

        if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
            $("#richardson-saving-option .cart-container .add-to-cart").removeClass("uk-disabled");
        } else {
            var alerttemplate = document.getElementById("m-alert-message").innerHTML;
            var render = Mustache.render(alerttemplate, {message: "Your roster is empty. Add item in your roster before adding to cart.", type: "primary"});

            $("#richardson-saving-option .cart-container .message-container").html("");
            $("#richardson-saving-option .cart-container .message-container").html(render);
            $("#richardson-saving-option .cart-container .add-to-cart").addClass("uk-disabled");
        }

        DesignPreview.events.reCaptcha = grecaptcha.render(document.getElementById('reCaptcha'), {
            'sitekey': window.reSiteKey
        });
    },

    afterLoadingDesignPreviewAssets: function() {
        var sdId = ub.current_material.settings.savedDesignID;
        var url = DesignPreview.events.getSavedDesignRedirectUrl();

        if (ub.data.isSavedDesign) {
            $(".save-design-container .goto-mysaved-design").removeClass("uk-hidden");
            $(".save-design-container .view-container").html("");
            $(".save-design-container .view-container")
                .html(`<a target="_blank" class="uk-button uk-width-1-1 fc-white bgc-darkGray abrade-ultra-italic hov-red" href="${url}"> View ${sdId}</a>`);
        }

        if (_.size(ub.current_material.settings.roster) > 0 && _.size(ub.current_material.settings.size_breakdown) > 0) {
            $("#richardson-saving-option .cart-container .add-to-cart").removeClass("uk-disabled");

            if (ub.data.addedToCart) {
                $("#richardson-saving-option button.add-to-cart").addClass("uk-disabled");
            }
        } else {
            var template = document.getElementById("m-alert-message").innerHTML;
            var render = Mustache.render(template, {message: "Your roster is empty. Add item in your roster before adding to cart.", type: "primary"});

            $("#richardson-saving-option .cart-container .message-container").html(""); 
            $("#richardson-saving-option .cart-container .message-container").html(render);
            $("#richardson-saving-option .cart-container .add-to-cart").addClass("uk-disabled");
        }
    },

    renderDesignPreview: function() {
        var template = '';
        
        if (ub.funcs.isTeam()) {
            template = document.getElementById("m-summary-team").innerHTML;
        } else if (ub.funcs.isDealer()) {
            template = document.getElementById("m-summary-dealer").innerHTML;
        } else if (ub.funcs.isPlayer()) {
            template = document.getElementById("m-summary-player").innerHTML;
        } else {
            template = document.getElementById("m-summary-guest").innerHTML;
        }

        var mySavedDesingURL = DesignPreview.events.getMySavedDesignURL();

        var renderTemplate = Mustache.render(template, {
            mySavedDesingURL
        });

        $("#richardson-saving-option .summary-content").html("");
        $("#richardson-saving-option .summary-content").html(renderTemplate);
        $("#richardson-saving-option .design-id").val(ub.config.material_id);

        DesignPreview.events.reCaptcha = grecaptcha.render(document.getElementById('reCaptcha'), {
            'sitekey': window.reSiteKey
        });
    },

    isAvailableToOrder: function(showMessage) {
        // Important Configuration
        var itemID = ub.current_material.material.item_id;
        var debugMode = ub.current_material.material.debug_mode;
        var price_item_template_id = ub.current_material.material.price_item_template_id;
        var qx_sizing_config = ub.current_material.material.qx_sizing_config;
        var sizing_config_prop = ub.current_material.material.sizing_config_prop;

        // Check availability
        var isAvailableToOrder = itemID !== null ||
                                    itemID !== 0 ||
                                    debugMode === 0 ||
                                    price_item_template_id !== "0" ||
                                    price_item_template_id !== null ||
                                    qx_sizing_config !== "0" ||
                                    qx_sizing_config !== null ||
                                    sizing_config_prop !== "0" ||
                                    sizing_config_prop !== null;

        if (showMessage) {
            if (isAvailableToOrder) {
                console.log("%c Style can be order.", "background: green; color: white");
            } else {
                console.warn("Style cannot be order. Please check misconfigure settings");
            }

            if (itemID !== null || itemID !== 0) {
                console.log("%c Style Item ID is set properly. Current value " + itemID, "background: green; color: white");
            } else {
                console.warn("Style Item ID is not configure properly. Current value: " + itemID);
            }

            if (debugMode !== 0) {
                console.warn("Debug Mode Value: " + debugMode);
            }

            if (price_item_template_id !== "0" || price_item_template_id !== null) {
                console.log("%c Price Item Template ID is properly configure. Current Value: " + price_item_template_id, "background: green; color: white");
            } else {
                console.warn("Price Item Template ID is not properly configure. Current Value: " + price_item_template_id);
            }

            if (qx_sizing_config !== "0" || qx_sizing_config !== null) {
                console.log("%c Qx Sizing Config is properly configure. Current Value: " + qx_sizing_config, "background: green; color: white");
            } else {
                console.warn("Qx Sizing Config is not properly configure. Current Value: " + qx_sizing_config);
            }

            if (sizing_config_prop !== "0" || sizing_config_prop !== null) {
                var parsedSizing = JSON.parse(ub.current_material.material.sizing_config_prop);
                console.log("%c Sizing config properties is properly configure.", "background: green; color: white");
                console.log("Sizing config properties: ", parsedSizing);
            } else {
                console.warn("Sizing config properties is not properly configure. Current Value: " + sizing_config_prop);
            }

            console.log("%c Customizer available: " + ub.current_material.material.customizer_available, "background: green; color: white");
        } else {
            return isAvailableToOrder;
        }
    },

    getMySavedDesignURL: function() {
        var mySavedDesingURL = `${ub.config.magentoURL}/saveandshare/index/mydesigns`;

        if (ub.config.isMagentoVersionTwo) {
            mySavedDesingURL = `${ub.config.magentoURL}/saveandsharedesign/index/mydesigns`
        }

        return mySavedDesingURL;
    },

    getSavedDesignRedirectUrl: function() {
        var sdId = ub.current_material.settings.savedDesignID;
        var url = `${ub.config.magentoURL}/uniform-saved-design/${sdId}`;

        if (ub.config.isMagentoVersionTwo) {
            url = `${ub.config.magentoURL}/uniform-saved-design?id=${sdId}`;
        }

        return url;
    }
};